<template>
  <section>
    <el-form :model="formObj" :rules="fromRules" ref="formObj" label-width="120px">
      <div class="title"><i></i>员工基本信息</div>
      <el-form-item label="姓名" prop="employeeName">
        <el-input maxlength="6" show-word-limit v-model="formObj.employeeName" auto-complete="off" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio v-model="gender"  label="1">男</el-radio>
        <el-radio v-model="gender"  label="0">女</el-radio>
      </el-form-item>
      <el-form-item label="身份证号" prop="employeeCode">
        <el-input maxlength="18" show-word-limit v-model="formObj.employeeCode" auto-complete="off" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="家庭住址">
        <el-input maxlength="50" show-word-limit v-model="formObj.employeeAddr" auto-complete="off" placeholder="请输入家庭住址"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="employeeTel">
        <el-input  maxlength="11" show-word-limit v-model="formObj.employeeTel" auto-complete="off" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="岗位角色" prop="roleId">
        <div v-if="isShowTree">
          <LinkageRole @roleSelected="roleSelected" @comSelected="comSelected" @proSelected="proSelected"
                       :option="option" :com-id="formData.user.comId"
                       :com-name="formData.user.comName" :pro-id="pId" :role-id="rId" :limit-seleced="0"></LinkageRole>
        </div>
      </el-form-item>
      <el-form-item  prop="projectId">
      </el-form-item>
      <el-form-item maxlength="50" show-word-limit label="开户行">
        <el-input maxlength="50" show-word-limit v-model="formObj.bank" auto-complete="off" placeholder="请输入开户行"></el-input>
      </el-form-item>
      <el-form-item label="银行卡号">
        <el-input maxlength="50" show-word-limit v-model="formObj.employeeBankcode" auto-complete="off" placeholder="请输入银行卡号"></el-input>
      </el-form-item>
<!--      <el-form-item label="是否管理人员" prop="isManager">-->
<!--        <el-radio v-model="isManager" label="1" >是</el-radio>-->
<!--        <el-radio v-model="isManager" label="0" >否</el-radio>-->
<!--      </el-form-item>-->
      <el-form-item label="照片采集">
        <el-upload
          :action="this.GLOBAL.baseServerPath+'/imgupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          list-type="picture-card"
          :limit="1"
          :on-exceed="handleExceed"
          :on-remove="fileRemove"
          :on-success="fileSuccess"
          :file-list="fileList">
          <div class="pic_btn"><i class="el-icon-plus"></i></div>
        </el-upload>
      </el-form-item>

      <div class="title"><i></i>进场交底单</div>
      <el-upload
        class="upload-demo"
        :action="this.GLOBAL.baseServerPath+'/fileupload'"
        :headers="this.GLOBAL.fileHeader"
        name="file"
        :limit="1"
        :on-exceed="handleExceed"
        :on-success="successDisUpload"
        :on-remove="removeDisUpload"
        :file-list="discloseList">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip"></div>
      </el-upload>
      <div class="title"><i></i>上传劳动合同</div>
      <el-upload
        class="upload-demo"
        :action="this.GLOBAL.baseServerPath+'/fileupload'"
        :headers="this.GLOBAL.fileHeader"
        name="file"
        :file-list="contractList"
        :limit="1"
        :on-exceed="handleExceed"
        :on-remove="removeConUpload"
        :on-success="successConUpload">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip"></div>
      </el-upload>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)" :disabled="btnDisabled">确定</el-button>
    </div>
  </section>
</template>

<script>

  import {userCreate,userUpdate,nameSingle,codeSingle,telSingle} from '../../api/api'
  import LinkageRole from "./LinkageRole";

  export default {
    name: "UserForm",
    components: {LinkageRole},
    props: {
      option: 0,
      formData:{},
      type:0,
    },
    data() {
      let validateName = (rule, value, callback) => {
        if(value!=null && value !=''){
          nameSingle({key:value}, this.GLOBAL.header).then(result => {
            if (result.success) {
              let n = result.data;
              if(this.option ==0){
                if(n==0){
                  callback();
                }
                else{
                  this.formObj.employeeName = value+'-'+n;
                  callback('姓名重复,系统自动添加标注');
                }
              }else {
                if(this.nameCheck == value){
                  callback();
                }else {
                  if(n==0){
                    callback();
                  }
                  else{
                    this.formObj.employeeName = value+'-'+n;
                    callback('姓名重复,系统自动添加标注');
                  }
                }
              }
            }else{
                callback(new Error('姓名重复'));
            }
          });
        }
      };
      let validateCode = (rule, value, callback) => {
        if(value!=null && value !=''){
          codeSingle({key:value}, this.GLOBAL.header).then(result => {
            if (result.success) {
              let n = result.data;
              if(this.option ==0){
                if(n==0){
                  callback();
                }
                else{
                  callback('该身份证号已被添加');
                }
              }else {
                if(this.codeCheck == value){
                  callback();
                }else {
                  if(n==0){
                    callback();
                  }
                  else{
                    callback('该身份证号已被添加');
                  }
                }
              }
            }else{
              callback('该身份证号已被添加');
            }
          });
        }
      };
      let validateTel = (rule, value, callback) => {
        if(value!=null && value !=''){
          telSingle({key:value}, this.GLOBAL.header).then(result => {
            if (result.success) {
              let n = result.data;
              if(this.option ==0){
                if(n==0){
                  callback();
                }
                else{
                  callback('该手机号已被添加');
                }
              }else {
                if(this.telCheck == value){
                  callback();
                }else {
                  if(n==0){
                    callback();
                  }
                  else{
                    callback('该手机号已被添加');
                  }
                }
              }
            }else{
                callback('该手机号已被添加');
            }
          });
        }
      };
      return {
        formObj: {},
        fromRules: {
          employeeName: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            { validator: validateName, trigger: 'blur' }
          ],
          employeeCode: [
            {required: true, message: '请输入身份证号', trigger: 'blur'},
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '身份证号码格式不正确',
              trigger: 'blur'
            },
            { validator: validateCode, trigger: 'blur' }
          ],
          employeeTel: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {pattern: /^0{0,1}(13[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/,message: '手机号码格式不正确',trigger: 'blur'},
            { validator: validateTel, trigger: 'blur' }

          ]
        },
        fileList: [],//上传的照片
        contractList:[],//上传的合同单
        discloseList:[],//上传的进场交底单
        gender:'1',
        isShowTree:false,
        linkObj:{},
        comId:null,
        proId:[],
        roleId:[],
        isManager:'1',
        rId:[],
        pId:[],
        btnDisabled:false,
        nameCheck:null,
        codeCheck:null,
        telCheck:null,
      }
    },
    methods: {
      //删除上传图片
      fileRemove(file, fileList) {
          this.formObj.employeePhoto = null;
      },
      //图片上传成功
      fileSuccess(response, file, fileList) {
        this.formObj.employeePhoto = response.data;
      },
      //上传交底单成功
      successDisUpload:function(response){
        this.formObj.employeeDisclose = response.data;
      },
      removeDisUpload:function(){
        this.formObj.employeeDisclose =null;
      },
      //上传合同成功
      successConUpload:function(response){
        this.formObj.employeeContract = response.data;
      },
      removeConUpload:function(){
        this.formObj.employeeContract=null;
      },
      //上传限制
      handleExceed: function (files,fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },

      doSubmit: function (option) {
        this.formObj.comId = this.comId;
        this.formObj.employeeGender = this.gender;
        this.formObj.isManager = this.type;
        //console.log(this.formObj);
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            if(this.comId==null || this.comId==0)
            {
              this.$message({
                message: "请选择所属公司",
                type: 'error'
              });
              return ;
            }
            if(this.roleId==null || this.roleId.length==0)
            {
              this.$message({
                message: "请选择岗位",
                type: 'error'
              });
              return ;
            }
            this.formObj.projectId = this.proId.join(',');
            this.formObj.roleId = this.roleId.join(',');

            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              if (option == 0) {
                userCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
              else if (option == 1) {
                this.formObj.uid = this.formObj.user.id;
                userUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel:function(){
        this.$emit('doCancel');
      },
      comSelected: function (id) {
        this.comId = id;
      },
      proSelected: function (proId) {
        this.proId = proId;
      },
      roleSelected:function(roleId) {
        this.roleId = roleId;
      },

    },
    mounted() {
      this.isShowTree = true;
      this.formObj = this.formData;

      //初始化添加表单
      if(this.option==0){}
      //初始化修改表单
      if(this.option==1){
        this.nameCheck = this.formObj.employeeName;
        this.codeCheck = this.formObj.employeeCode;
        this.telCheck = this.formObj.employeeTel;
        this.isManager = this.formObj.user.isManager+'';
        if(this.formObj.user.projectId!=null){
          let p = this.formObj.user.projectId.split(',');
          for (let i = 0; i < p.length; i++) {
            if(p[i] != null && p[i]!=''){
              this.pId[i] = parseInt(p[i]);
            }
          }
        }
        if(this.formObj.user.roleId!=null){
          let p = this.formObj.user.roleId.split(',');
          for (let i = 0; i < p.length; i++) {
            this.rId[i] = parseInt(p[i]);
          }
        }
        if(this.formObj.employeePhoto!=null && this.formObj.employeePhoto!='') {
          this.fileList.push({url: this.GLOBAL.basePhotoPath + "" + this.formObj.employeePhoto});
        }
        if(this.formObj.employeeDisclose!=null && this.formObj.employeeDisclose!='') {
          this.discloseList.push({url: this.GLOBAL.basePhotoPath + "" + this.formObj.employeeDisclose});
        }
        if(this.formObj.employeeContract!=null && this.formObj.employeeContract!='') {
          this.contractList.push({url: this.GLOBAL.basePhotoPath + "" + this.formObj.employeeContract});
        }

        this.gender = this.formObj.employeeGender+'';
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/UserForm.vue